import React from 'react'
import BodyLogo from '../../components/BodyLogos/BodyLogo'
import Footer from '../../components/Footer/Footer'
import FormElement from '../../components/FormElement/FormElement'
import Header from '../../components/Header/Header'
export default function SignUpPage() {
  return (
   <div className="auth-page">
   <Header />
   <FormElement/>
   <BodyLogo/>
   <Footer/>
   </div>
  )
}
